import React from 'react'
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Shared from '../services/Shared';
import styles from './Schedule.module.css'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Navbar from './Navbar'
import Pets from '@material-ui/icons/Pets';
import Api from '../services/Api'
import Util from '../../Util'

export default function Schedule({ location }) {

    const searchParams = new URLSearchParams(location.search);
    const semesterParam = searchParams.get('semester');

    const [schedule, setSchedule] = React.useState([]);
    const [isConfirmOpen, setIsConfirmOpen] = React.useState(false);
    const [isDrop, setIsDrop] = React.useState(false);
    const [selectedClass, setSelectedClass] = React.useState('');
    const [selectedIndex, setSelectedIndex] = React.useState(0);
    const [semester, setSemester] = React.useState(semesterParam || "Fall");

    React.useEffect(() => {
        if (!semester) {
            return;
        }

        Api.getSchedule(semester, response => {
            setSchedule(response.length ? response : null);
        });
    }, [semester])

    function onConfirm() {

        Api.deleteSchedule(schedule[selectedIndex].id, () => {

            const newSchedule = schedule.filter((_, i) => i !== selectedIndex);
            setSchedule(newSchedule.length ? newSchedule : null);
    
            setIsDrop(false);
            setIsConfirmOpen(false);
        });
    }

    function onConfirmCancel() {
        setIsDrop(false);
        setIsConfirmOpen(false);
    }

    function onDownload() {

        Api.getSchedulePdf(semester, response => {

            const a = document.createElement('a');
            a.href = `data:application/pdf;base64,${response.base64}`;
            a.download = response.name;
            a.click();
        });
    }

    function onDrop() {
        setIsDrop(true);
    }

    function onSemester(e) {
        setSemester(e.target.value);
    }

    function onX(class_, index) {
        setSelectedClass(class_);
        setSelectedIndex(index);
        setIsConfirmOpen(true);
    }

    return (
        <>
            <Navbar></Navbar>
            <div className={styles.contain}>
                <div>
                    <h1>Schedule &nbsp; <Pets /> </h1>
                </div>
                <div>
                    <FormControl variant="filled" className={styles.semesterSelect}>
                        <InputLabel id="semester">Semester</InputLabel>
                        <Select
                            labelId="semester"
                            id="filled"
                            value={semester}
                            onChange={onSemester}
                        >
                            {Shared.semesters.map(s => {
                                return <MenuItem key={s} value={s}>{s}</MenuItem>;
                            })}
                        </Select>
                    </FormControl>
                </div>
                {schedule && schedule.map((d, i) => {
                    return (
                        <div className={styles.card} key={i}>
                            <div className={styles.head}>
                                <div className={styles.title}>{d.clss.course.name}</div>
                                <div className={isDrop ? styles.xButton : `${styles.xButton} ${styles.hide}`} onClick={e => onX(d.clss, i)}>X</div>
                            </div>
                            <div className={styles.details}>
                                <div>{d.clss.days}</div>
                                <div>{Util.toFETime(d.clss.timeSt)} - {Util.toFETime(d.clss.timeEnd)}</div>
                                <div>Bldg {d.clss.bldg}</div>
                            </div>
                        </div>
                    )
                })}

                {schedule &&
                    <div className={styles.buttons}>
                        <div className={styles.downloadButton}>
                            <Button size="large" onClick={onDownload}>Download</Button>
                        </div>
                        <div className={isDrop ? `${styles.dropButton} ${styles.hide}` : styles.dropButton}>
                            <Button size="large" onClick={onDrop}>Drop Classes</Button>
                        </div>
                    </div>
                }
                {!schedule &&
                    <div className={styles.notRegistered}>
                        You have not registered for any classes yet
                    </div>
                }

                <Dialog
                    open={isConfirmOpen}
                    onClose={onConfirmCancel}
                    aria-labelledby="title"
                    aria-describedby="desc"
                >
                    <DialogTitle id="title">{"This class will be dropped"}</DialogTitle>
                    <DialogContent>
                        {selectedClass && (
                            <div>
                                <div>{selectedClass.course.name}</div>
                                <div className={styles.confirmTime}>
                                    <div className={styles.confirmSemester}>{selectedClass.semester}</div>
                                    <div>{selectedClass.days} at {Util.toFETime(selectedClass.timeSt)} - {Util.toFETime(selectedClass.timeEnd)}</div>
                                </div>
                            </div>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={onConfirmCancel} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={onConfirm} color="primary" autoFocus>
                            Confirm
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </>
    )
}